import { UserRole } from '@/types';

export type EffectiveRole = 'super_admin' | 'admin' | 'manager' | 'engineer';

export const normalizeRole = (role?: UserRole | string | null): EffectiveRole => {
  if (!role || typeof role !== 'string') return 'engineer';
  const normalized = role.trim().toLowerCase();

  if (normalized === 'super_admin') return 'super_admin';
  if (normalized === 'admin') return 'admin';

  // Manager-level roles (aligned with backend rbac.ts)
  if (
    normalized === 'manager' ||
    normalized === 'team_lead' ||
    normalized === 'project_manager' ||
    normalized === 'department_head'
  ) {
    return 'manager';
  }

  // Engineer-level roles
  if (normalized === 'engineer' || normalized === 'individual_contributor') {
    return 'engineer';
  }

  return 'engineer';
};

export const isSuperAdmin = (role?: UserRole | string | null): boolean => {
  return normalizeRole(role) === 'super_admin';
};

export const isAdminOrAbove = (role?: UserRole | string | null): boolean => {
  const effective = normalizeRole(role);
  return effective === 'super_admin' || effective === 'admin';
};

export const isAdminOrManager = (role?: UserRole | string | null): boolean => {
  const effective = normalizeRole(role);
  return effective === 'super_admin' || effective === 'admin' || effective === 'manager';
};
